import { Component, signal, viewChild, ElementRef, Signal, input, InputSignal, WritableSignal, OnChanges, SimpleChanges, inject, output, OutputEmitterRef, OnInit, computed, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonContent, IonButton, IonIcon, IonTextarea, IonSpinner } from "@ionic/angular/standalone";
import { addIcons } from "ionicons";
import { chevronUp } from "ionicons/icons";
import { FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { GlobalService } from 'src/app/services/global.service';
import { AuthService } from 'src/app/services/auth.service';
import { ChatMessage } from "src/app/models/chat-message"; 
import { HttpClient } from '@angular/common/http';
import { MarkdownService } from 'ngx-markdown';
import { MoodleWebService } from 'src/app/services/moodle-web.service';

@Component({
  selector: 'app-chat-modal',
  templateUrl: './chat-modal.component.html',
  styleUrls: ['./chat-modal.component.scss'],
  imports: [IonSpinner, CommonModule, IonIcon, IonButton, IonContent, FormsModule, ReactiveFormsModule, IonTextarea]
})
export class ChatModalComponent  implements OnChanges, OnInit {
  http = inject(HttpClient);
  markdown = inject(MarkdownService);

  userPrompt = new FormControl('');

  currentChat: InputSignal<number> = input<number>(-1);  
  currentContext: InputSignal<string | null> = input<string | null>(null);  
  chatContext: OutputEmitterRef<any>  = output<any>();

  isThinking: WritableSignal<boolean> = signal(false);
  messageArray: Signal<ChatMessage[]> = computed<ChatMessage[]>(() => this.globalService.currentChat());

  messagesList: Signal<ElementRef<HTMLElement>> = viewChild.required<ElementRef<HTMLElement>>('messagesList');
  scrollContainer: Signal<ElementRef<HTMLElement>> = viewChild.required<ElementRef<HTMLElement>>('scrollContainer');

  initChat: WritableSignal<any> = signal(null);
  hideInitMsg: WritableSignal<boolean> = signal(false);

  constructor(public globalService: GlobalService, public authService: AuthService, private moodleWebService: MoodleWebService) {
    addIcons({chevronUp});       
    effect(() => {      
      if (this.messageArray().length === 0) {
        setTimeout(() => {
          this.hideInitMsg.set(false);
        }, 100)
      }
      else{
        this.hideInitMsg.set(true);
      }
    })   
  }

  async ngOnInit() {
    this.initChat.set(await this.globalService.setInitMsg());
  }

  async ngOnChanges(changes: SimpleChanges) {        
    if(changes['currentChat'].isFirstChange()) {        
      // this.globalService.currentChat.set([await this.globalService.setInitMsg()]);
    }
    else{
      this.messagesList().nativeElement.classList.add('anim');            
      setTimeout(()=>{
        this.messagesList().nativeElement.classList.remove('anim');
        this.scrollToBottom("instant");
      }, 250)
    }    
  }
  
  sendMessage() {
    if(this.userPrompt?.value && this.userPrompt.value !== ""){
      if (this.currentContext() === null) {
        this.chatContext.emit(null);   
        this.hideInitMsg.set(true);    
      }
      this.isThinking.set(true);

      let newMessage = {
        id: this.currentChat() !== -1 ? this.currentChat() + '.' + (this.messageArray().length + 1) : '0.' + (this.messageArray().length + 1),
        sender: 'userName',
        text: this.userPrompt.value!,
        date: this.globalService.getCurrentDay(),
        time: this.globalService.getCurrentTime()
      }            
      
      this.globalService.currentChat.update(msg => [...msg, newMessage]);    

      const data = {
        message: {
          uid: this.authService.currentUser().auth.id,
          context: this.currentContext(),
          message: this.userPrompt.value,
          role: "user"
        },
        competencies: this.moodleWebService.referentiel() !== undefined ? this.moodleWebService.referentiel() : null,
        passport: this.moodleWebService.passport().length > 0 ? this.moodleWebService.passport() : null,
        student: this.moodleWebService.userMoodleData() !== undefined ? this.moodleWebService.userMoodleData() : null
      }    

      this.globalService.sendMessage(data).then((response: any) => {
        if (this.currentContext() === null) this.chatContext.emit(response.context);
        this.isThinking.set(false);
      })

      this.scrollToBottom("smooth");
      this.userPrompt.setValue('');    
    }
  }

  sendMsgEnter($event: any) {
    if ($event.keyCode == 13) {
      $event.preventDefault();
      this.sendMessage();
    }
  }

  scrollToBottom(behaviorParam: ScrollBehavior) {
    setTimeout(() => {
      this.scrollContainer().nativeElement.scrollTo({top: this.scrollContainer().nativeElement.scrollHeight, left: 0, behavior: behaviorParam});
    }, 0)    
  }
}
